e360.controller('EventFacebookController', [
   '$scope',
   '$location',
   'facebookApi',
   'toast',

   function ($scope, $location, facebookApi, toast) {
      var locals = {
         init: function () {
            $scope.isFacebookConfigured = false;
            $scope.isLoggedIn = false;

            $scope.$watch('model.selectedEvent', function (value) {
               $scope.isBusy = false;
               $scope.error = null;
               $scope.success = false;

               if (value) {
                  facebookApi.getConfig(value.id).then(function (config) {
                     $scope.isFacebookConfigured = (config.pageId && config.appId);
                     if ($scope.isFacebookConfigured) {
                        if (config.pageAccessToken) {
                           $scope.isLoggedIn = true;
                        } else {
                           $scope.isLoggedIn = false;
                        }
                     }
                  });
               }
            });
         }
      };

      $scope.post = function () {
         $scope.isBusy = true;
         $scope.error = null;
         $scope.success = null;

         facebookApi.postToFacebook($scope.model.selectedEvent.id).then(function () {
            toast.success()
               .message('Posted to Facebook!')
               .send();
            $scope.success = true;
            $scope.isBusy = false;
         }, function (error) {
            $scope.error = error;
            $scope.isBusy = false;
         });
      };

      $scope.facebookLoginUrl = function () {
         if (!$scope.isFacebookConfigured || !$scope.model.selectedEvent) {
            return;
         }

         return facebookApi.getLoginUri($scope.model.selectedEvent.id,
            $location.absUrl());
      };

      locals.init();

   }
]);
